// Componentes de Analytics - DÍA 5 Sub-paso 5.2.1
// Sistema de componentes de analytics especializado para dashboards por rol

import type { App } from 'vue'

// Importaciones de componentes de analytics
import AnalyticsReadonlyPanel from './AnalyticsReadonlyPanel.vue'
import DashboardAnalytics from './DashboardAnalytics.vue'
import AnalyticsTracker from './AnalyticsTracker.vue'
import MetricCard from './MetricCard.vue'
import TrendIndicator from './TrendIndicator.vue'
import DataTable from './DataTable.vue'
import FilterPanel from './FilterPanel.vue'
import FilterControl from './FilterControl.vue'
import DateRangePicker from './DateRangePicker.vue'

// Componentes principales exportados
export { default as AnalyticsReadonlyPanel } from './AnalyticsReadonlyPanel.vue'
export { default as DashboardAnalytics } from './DashboardAnalytics.vue'
export { default as AnalyticsTracker } from './AnalyticsTracker.vue'
export { default as MetricCard } from './MetricCard.vue'
export { default as TrendIndicator } from './TrendIndicator.vue'
export { default as DataTable } from './DataTable.vue'
export { default as FilterPanel } from './FilterPanel.vue'
export { default as FilterControl } from './FilterControl.vue'
export { default as DateRangePicker } from './DateRangePicker.vue'

// Plugin para registro en Vue
export default {
  install(app: App) {
    // Registrar todos los componentes de analytics
    app.component('AnalyticsReadonlyPanel', AnalyticsReadonlyPanel)
    app.component('DashboardAnalytics', DashboardAnalytics)
    app.component('AnalyticsTracker', AnalyticsTracker)
    app.component('MetricCard', MetricCard)
    app.component('TrendIndicator', TrendIndicator)
    app.component('DataTable', DataTable)
    app.component('FilterPanel', FilterPanel)
    app.component('FilterControl', FilterControl)
    app.component('DateRangePicker', DateRangePicker)
    
    console.log('✅ Componentes de Analytics registrados')
  }
}

// Tipos y interfaces para analytics
export interface MetricData {
  label: string
  value: number | string
  trend?: 'up' | 'down' | 'stable'
  trendPercent?: number
  format?: 'number' | 'percentage' | 'currency' | 'text'
}

export interface ChartConfig {
  type: 'line' | 'bar' | 'pie' | 'doughnut' | 'area'
  data: any[]
  options?: any
}

export interface FilterOption {
  label: string
  value: any
  disabled?: boolean
}

export interface DateRange {
  start: Date | string
  end: Date | string
}

export interface AnalyticsConfig {
  role: string
  permissions: string[]
  enabledCharts: string[]
  enabledActions: string[]
  readOnlyMode: boolean
}
